import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { Dialog as g, Box as p, Button as a } from "@mui/material";
import { DatePicker as v } from "@mui/x-date-pickers";
import x from "dayjs";
import { message as u } from "../../../queries/message/index.js";
import "../../../queries/contact/index.js";
import "../../../queries/calendars/index.js";
import "../../../pointsGraph-DTJju-rA.js";
import "../../../queries/student/index.js";
import "../../../queries/settings/index.js";
import "../../../queries/points/index.js";
import "../../../queries/assessment/index.js";
import "../../../queries/assessment/annotations/index.js";
import "../../../queries/assessment/rubrics/index.js";
import "../../../queries/assessment/qcesubjects/index.js";
import "../../../queries/assessment/extensionrequest/index.js";
import "../../../queries/files/index.js";
import "../../../queries/attendance/index.js";
import "../../../queries/forms/index.js";
import "../../../queries/notifications/index.js";
import "../../../queries/interviews/index.js";
import "../../../queries/notes/index.js";
import "../../../queries/annoucements/index.js";
import "../../../queries/payments/index.js";
import "../../../queries/assessment/analysis/index.js";
import "../../../queries/group/index.js";
import "../../../queries/projects/index.js";
import "../../../queries/courses/index.js";
import "../../../queries/password/index.js";
import { LoadingOverlay as y } from "../../loadingoverlay/index.js";
import { useState as D } from "react";
const Z = ({ onMessagesArchived: n, folderId: c, all: e, onClose: m, open: s }) => {
  const [r, l] = D(/* @__PURE__ */ new Date()), { isFetching: f, refetch: d } = new u.folders.archiveAll({ data: {
    folderId: c,
    cutOff: r,
    all: e
  } }).ToQuery(), h = async () => {
    r && (await d(), n());
  };
  return /* @__PURE__ */ o(g, { open: s, onClose: m, children: [
    /* @__PURE__ */ t(
      y,
      {
        open: f,
        text: "Archiving messages"
      }
    ),
    /* @__PURE__ */ o(p, { sx: { display: "flex", flexFlow: "column", gap: 1, alignItems: "center", px: 1, py: 2 }, children: [
      /* @__PURE__ */ t(v, { label: `Archive ${e ? "all" : "read"} messages from before`, onChange: (i) => l(i == null ? void 0 : i.toDate()), value: x(r) }),
      /* @__PURE__ */ o(p, { children: [
        /* @__PURE__ */ t(a, { onClick: m, children: "Cancel" }),
        /* @__PURE__ */ t(a, { variant: "contained", onClick: h, disabled: !r, children: "Archive" })
      ] })
    ] })
  ] });
};
export {
  Z as ArchiveFromDatePicker
};
//# sourceMappingURL=ArchiveFromDatePicker.js.map
